import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    counterWrapper: {
      borderColor: colors.blueBrand,
      borderRadius: '3px',
      display: 'flex',
      flex: 1,
      margin: '0 1vw',
      [theme.breakpoints.down('768')]: {
        width: '50vw',
      },
    },
    input: {
      backgroundColor: colors.white,
      borderColor: colors.blueBrand,
      borderWidth: '3px',
    },
    focused: {
      backgroundColor: colors.white,
    },
  })
);
